import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing } = useTheme();

  return {
    link: (isMobile, isInline) => css`
      text-align: center;
      text-transform: uppercase;
      color: ${colors.blue};
      font-size: 0.875rem;
      font-weight: 400;
      &:not(:disabled) {
        &:hover {
          color: ${colors.white};
        }
      }
      ${breakpoints.mm_l_xl}{
        font-size: 1rem;
      }
      ${breakpoints.l} {
        display: ${isInline ? 'inline-block' : 'block'};
      }

      ${isMobile &&
      css`
        display: ${isInline ? 'inline-block' : 'block'};
      `};
    `,
    directionSpace: css`
      padding-left: ${spacing.xs};
      letter-spacing: 0.32px;
      line-height: 25px;
    `,
    linkMobile: css`
      // since geo location is not working
      display: none;
    `,
  };
};
